import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import PropTypes from 'prop-types';
import Loader from "components/Loader";
import AddressService from "services/Address/";
import { actionsType } from 'config/constants';
import style from './style.scss'; //NOSONAR

let settings = null;

const PersistsAddress = (props) => {

    const [loading, setLoading] = useState(false);
    const [adresses, setAdresses] = useState([]);


    useEffect(() => {

        _open(props.payload)

    }, [props.payload])

    const _open = (payload) => {
        if(payload && payload.open){
            if(payload.value){
                settings = payload.value;
            } else {
                settings = {
                    successCallback: false
                };
            }
    
            const adresses = AddressService.getAnonymousAdresses();
    
            if (adresses) {
                setAdresses(adresses);
            } else {
                _nextStep();
            }
        }
    }

    const _nextStep = () => {
        const address = AddressService.getSelectedAdress();

        AddressService.clearAnonymousAdresses();

        _close();
        if(settings.successCallback && (!settings.successCallback.toString().includes('function(){}')) ){

            settings.successCallback();

        } else {
            if(!address) {
                setTimeout(() =>  {
                    PubSub.dispatch('delivery_selector_open', settings);
                }, 0);
            }
        }
    }

    const getFullAddress = (address) => {
        return AddressService.getFullAddress(address);
    }

    const _close = () => {
        setTimeout(() => PubSub.dispatch(actionsType.MODAL.PERSISTS_ADDRESS_CLOSE), 0);
    }

    const saveAdresses = () => {
        setLoading(true);

        let consults = adresses.map(address => AddressService.addAddress(address));

        Promise.all(consults).then(() => {
            setLoading(false);
            PubSub.dispatch('address_updated');
            _nextStep();
        });
    }

    const cancel = () => {
        _nextStep();
    }

    return (
        <div className="new-modal-container">
            <div className='new-modal-scroll'>
                <h3 className="new-modal-title">Direcciones</h3>
                {loading && <div className="modal-persists-address-loader"> <Loader /> </div>}
                <h4 className='modal-persists-address-subtitle'>Notamos que creaste estas direcciones sin ingresar a tu cuenta</h4>

                <ul className='modal-persists-address-list'>
                    {adresses.map((address, i) => <li className='modal-persists-address-item' key={i}>
                        {getFullAddress(address)}
                    </li>)}
                </ul>

                <label className='modal-persists-address-label'>¿Deseas guardarlas en tus direcciones?</label>
            </div>
            <div className="modal-actions ">
                <button type="button" className='secundary-btn modal-persists-address-actions-cancel' onClick={cancel}>
                    No
                </button>
                <button type="button" className="primary-btn modal-persists-address-actions-submit" onClick={saveAdresses}>
                    Sí
                </button>
            </div>
        </div>
    )
}

PersistsAddress.propTypes = {
    payload: PropTypes.object
}


export default PersistsAddress;
